import styled from 'styled-components';

import FieldsSection from '../../components/FieldsSection';
import { FieldsSectionColumnsCount } from './SectionFields.types';

export const GridContainer = styled.div<FieldsSectionColumnsCount>`
    display: flex;
    flex-flow: row wrap;
`;

export const GridItem = styled(FieldsSection.Field)<FieldsSectionColumnsCount>`
    width: calc(100% / ${(props) => props.columnsCount || 3});
    margin-bottom: 34px;
    padding-right: 10px;
`;
